import asset from './asset';
import curation from './curation';
import dimensions from './dimensions';
import file from './file';
import module from './module';
import project from './project'; 

export default {
  asset,
  curation,
  dimensions,
  file,
  module,
  project
};


// WEBPACK FOOTER //
// ./src/lib/CustomPropTypes/index.js